import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { TaskResponse } from "@/models/api/administration/taskScheduler/Task";
import { TaskEdit } from "@/models/api/administration/taskScheduler/TaskEdit";
import { User } from "@/models/api/administration/users/User";

//#region Routes
export const URL_GET_TASK_PAGED = "/TaskScheduler/TasksList/Paged";
export const URL_GET_TASK_BY_ID = "/TaskScheduler/ScheduleTaskById";
export const URL_POST_RESTART_SCHEDULE = "/TaskScheduler/RestartSchedule";
export const URL_POST_TOGGLE_TASK = "/TaskScheduler/ToggleTask";
export const URL_POST_MANUAL_START_TASK = "/TaskScheduler/ManualStartTask";
export const URL_POST_EDIT_TASK = "/TaskScheduler/EditTask";
export const URL_GET_TASK_USERS = "/TaskScheduler/GetTaskUsers";
export const URL_POST_EDIT_TASK_USERS = "/TaskScheduler/EditTaskUsers/${TaskId}";
export const URL_GET_USER_TASKS = "/TaskScheduler/GetUserTasks";
export const URL_POST_TOGGLE_USER_TASK = "/TaskScheduler/ToggleUserTask";
//#endregion

const _getTaskTable = new CancellableHelper<TaskResponse>(URL_GET_TASK_PAGED, TaskResponse);
_getTaskTable.jsonSerializer = true;
export const getTaskTable = async (genericTableRequest: GenericTableRequest): Promise<TaskResponse> => {
  return await _getTaskTable.get(genericTableRequest);
};

const _getUserTasks = new CancellableHelper<TaskResponse>(URL_GET_USER_TASKS, TaskResponse);
_getUserTasks.jsonSerializer = true;
export const getUserTasks = async (genericTableRequest: GenericTableRequest): Promise<TaskResponse> => {
  return await _getUserTasks.get(genericTableRequest);
};

export const restartTask = async (taskId: number): Promise<null> => {
  const _restartTask = new CancellableHelper<null>(URL_POST_RESTART_SCHEDULE, null, true);
  return await _restartTask.post({ taskId: taskId }, null);
};

export const toggleTask = async (taskId: number): Promise<null> => {
  const _toggleTask = new CancellableHelper<null>(URL_POST_TOGGLE_TASK, null, true);
  return _toggleTask.post({ taskId: taskId }, null);
};

export const toggleUserTask = async (taskId: number): Promise<null> => {
  const _toggleUserTask = new CancellableHelper<null>(URL_POST_TOGGLE_USER_TASK, null, true);
  return _toggleUserTask.post({ taskId: taskId }, null);
};

export const runTaskManually = async (taskId: number): Promise<null> => {
  const _runTask = new CancellableHelper<null>(URL_POST_MANUAL_START_TASK, null, true);
  return _runTask.post({ scheduleId: taskId }, null);
};

const _getTaskType = new CancellableHelper<TaskEdit>(URL_GET_TASK_BY_ID, TaskEdit);
export const getTaskType = async (taskId: number): Promise<TaskEdit> => {
  return await _getTaskType.get({ taskId: taskId });
};

const _editTaskType = new CancellableHelper<TaskResponse>(URL_POST_EDIT_TASK, null, true);
export const editTaskType = async (taskScheduler: TaskEdit, taskEditId: number): Promise<TaskResponse> => {
  return await _editTaskType.post({ taskId: taskEditId }, taskScheduler);
};

const _getTaskUsers = new CancellableHelper<Array<User>>(URL_GET_TASK_USERS, User);
export const getTaskUsers = async (): Promise<Array<User>> => {
  return await _getTaskUsers.get();
};

const _editTaskUsers = new CancellableHelper<TaskResponse>(URL_POST_EDIT_TASK_USERS, null, true);
export const editTaskUsers = async (taskId: number, userIds: Array<string>): Promise<TaskResponse> => {
  return await _editTaskUsers.post({ TaskId: taskId }, userIds);
};
